import ReceiptIcon from '@mui/icons-material/Receipt'
import { MENU_GROUPS } from '@/lib/routes/menuGroups'

export const routeFrontOfficeInvoices = [
  {
    route: 'Invoices',
    text: 'Facturation',
    t: 'routes.frontoffice.all.invoices',
    icon: ReceiptIcon,
    href: '/frontoffice/group/invoices',
    menuHeader: true,
    // Menu v2 : rattache a la section commune « Ma pharmacie » (dedoublonne cross-entites).
    menuGroup: MENU_GROUPS.PHARMACY,
    position: 110,
    // Menu v2 : remonte dans « Actions a faire » quand des factures disponibles restent a signer.
    actionable: true,
    fnBadge: ({ dataMyProfile }) =>
      !!dataMyProfile?.counterTaskEntityForMenu
        ? JSON.parse(dataMyProfile?.counterTaskEntityForMenu)?.invoicesToSign
        : 0,
  },
  {
    route: 'InvoicesSuccess',
    href: '/frontoffice/group/invoices/invoices-success',
    position: 120,
  },
]
